<template>
    <header class="">
        <div class="sm:block hidden">
            <email-verified-message />
            <top-bar-message />
        </div>
        <div class="flex justify-between items-center md:hidden static fixed w-full z-50 px-2 bg-white border-b">
            <div class="flex w-15">
                <span v-on:click="navigation_show=!navigation_show" class="material-icons text-gray-500 p-3">menu</span>
            </div>

            <div v-if="isClientSide()" class="flex items-center w-70">
                <a href="/" class="header-company-logo block" name="happytrainers logo" title="happytrainers logo">
                    <img class="img-fluid" :src="$page.props.configs.companyLogo" width="152" height="48" alt="happytrainers logo">
                </a>
            </div>
            <div v-if="isClientSide()" class="flex items-center w-15" style="margin-top: 7px">
                    <a v-if="$page.props.user" :href="$page.props?.user?.role==='master' ? '/dashboard/master/courses' : '/dashboard/user/profile'">
                        <span class="material-icons" style="font-size: 30px;">perm_identity</span>
                    </a>
                    <a v-else v-on:click="navigation_show=!navigation_show">
                        <span class="material-icons mr-2" style="font-size: 25px;">input</span>
                    </a>
            </div>
        </div>

        <div v-if="navigation_show" class="bg-white backdrop-saturate-100 fixed pt-5 z-40 w-3/4 drop-shadow-md min-h-screen">
            <div class="p-3">
                <div v-if="!$page.props.user" class="p-3">
                    <ul class="mt-8 text-gray-500 font-bold ps-0">
                        <li class="flex items-center my-3 list-none">
                            <span class="material-icons inline text-[30px]">input</span>
                            <a class="mt-2 ml-3 text-[16px]" href="/login">
                                Log in
                            </a>
                        </li>
                        <li class="flex items-center my-3 list-none">
                            <span class="material-icons inline text-[30px]">how_to_reg</span>
                            <a class="mt-2 ml-3 text-[16px]" href="/register?role=student">
                                Sign up
                            </a>
                        </li>
                    </ul>
                    <hr class="my-3" />
                    <div>
                        <h4 class="text-xl text-gray-800">Join as a professional</h4>
                        <ul class="ps-0">
                            <li @click="goTo('/become-a-personal-trainer')" class="mt-2 hover:shadow-xl py-1 px-3 transition ease-in-out duration-500 rounded-lg list-none">
                                Become a personal trainer
                            </li>
                            <li @click="goTo('/become-a-yoga-instructor')" class="mt-2 hover:shadow-xl py-1 px-3 transition ease-in-out duration-500 rounded-lg list-none">
                                Become a yoga instructor
                            </li>
                        </ul>
                    </div>
                    <hr class="my-3" />
                    <div>
                        <h4 class="text-xl text-gray-800">Services</h4>
                        <ul class="ps-0">
                            <li v-for="(category,key) in $page.props.categories"
                                :class="getCurrentUrl().toString().trim().split('/')[4]===category.url ? 'bg-gray-300' : ''"
                                :key="key"
                                class="mt-2 hover:shadow-xl py-1 px-3 transition ease-in-out duration-500 rounded-lg list-none">
                                <a :href="`/${category.url}/online`"
                                      class="flex items-center">
                                    <img class="w-8 h-8 mx-2" :title="category.title" :alt="category.title" :src="category.image || $page.props.configs.companyLogo">
                                    {{ category.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="p-3">
                    <div class="pt-4 flex items-center px-4">
                        <div v-if="$page.props.user.profile_photo_url" class="flex-shrink-0 mr-3" >
                            <img class="h-20 w-20 rounded-full object-cover" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.first_name" />
                        </div>

                        <div class="mt-2">
                            <!-- <span class="m-2 flex justify-center">
                                <span class="material-icons inline text-gray-500 mx-2">
                                    notifications
                                </span>
                            </span> -->
                            <div class="font-medium text-sm text-gray-500">{{ $page.props.user.fullName }}</div>
                        </div>
                    </div>
                    <div class="mt-5 space-y-1">
                        <div 
                            v-for="(item,key) in menuOptions" 
                            :key="key" 
                            class="text-gray-500 font-bold" 
                        >
                            <li v-if="item.condition" class="flex items-center my-3 list-none">
                                <span class="material-icons inline text-[30px]">{{ item.icon }}</span>
                                <a class="mt-2 ml-3 text-[16px]" :href="item.link">
                                    {{ item.title }}
                                </a>
                            </li>
                        </div>
                        <hr class="my-1" />
                        <div class="text-gray-500 font-bold">
                            <form class="flex items-center my-3" @submit.prevent="logout">
                                <span class="text-gray-500 font-bold material-icons mr-1 menu-icon">logout</span>
                                <button type="submit" class="text-gray-500 font-bold mt-2 ml-3 text-[16px]" >
                                    logout
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sm:hidden block pt-[48px]">
            <email-verified-message />
            <top-bar-message />
        </div>

        <div :class="headerBackground() ? 'bg-white text-gray-700' : ''"
             class="hidden md:flex w-full shadow-xl z-50 container container-md mx-auto rounded-full mb-4">
            <div class="flex-grow items-center px-3 flex justify-items-stretch justify-between container container-xl mx-auto">
                <div :class="headerBackground()? 'text-gray-700  divide-gray-500' : 'text-white  divide-white'"
                     class="flex divide-x my-2 align-items-center">
                    <div class="px-4 w-full">
                        <a href="/" class="header-company-logo block" name="happytrainers logo" title="happytrainers logo">
                            <img class="img-fluid" :src="$page.props.configs.companyLogo" width="152" height="48" alt="happytrainers logo">
                        </a>
                    </div>
                    <div v-on:mouseleave="listBox=false" class="header-speciality-lists px-4 grid text-center relative w-full">
                        <div v-on:mouseover="listBox=true"
                             class=" grid cursor-pointer">
                            <span class="pt-3">Find Trainers</span>
                            <span class="material-icons -mt-2">expand_more</span>
                        </div>
                        <div v-on:mouseleave="listBox=false" v-on:mouseover="listBox=true" v-if="listBox" class="p-3 top-10 absolute border w-42 right-0 bg-white rounded-md backdrop-saturate-100 bg-opacity-30 backdrop-filter backdrop-blur-xl drop-shadow-md shadow-xl z-50">
                            <ul class="ps-0">
                                <li v-for="category in $page.props.categories" class="mb-2 hover:text-gray-500 hover:bg-indigo-100 hover:text-indigo-600 p-1 rounded-md list-none">
                                    <a :href="`/${category.url}/online`">{{ category.title }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class=" text-center items-center flex pl-3 px-4 hover:text-green-500">
                        <span class="material-icons py-2">phone_in_talk</span>
                        <a :href="`tel:${$page.props.configs.phone}`">{{ $page.props.configs.phone }}</a>
                    </div>
                    <div class=" place-items-center text-center px-4">
                        <a :href="`/help`" class="hover:text-green-500">
                            <span class="material-icons pb-3 pt-2">help_outline</span>
                        </a>
                    </div>

                    <div v-if="!$page.props.user" v-on:mouseleave="joinProfessional=false" class="px-4 grid text-center relative w-full">
                        <div v-on:mouseover="joinProfessional=true"
                             class=" grid cursor-pointer">
                            <span class="pt-3">Join as a professional</span>
                            <span class="material-icons -mt-2">expand_more</span>
                        </div>
                        <div v-on:mouseleave="joinProfessional=false" v-on:mouseover="joinProfessional=true" v-if="joinProfessional" class="py-3 px-[20px] top-10 absolute border w-42 right-0 bg-white rounded-md backdrop-saturate-100 bg-opacity-30 backdrop-filter backdrop-blur-xl drop-shadow-md shadow-xl z-50">
                            <ul class="ps-0">
                                <li @click="goTo('/become-a-personal-trainer')" class="cursor-pointer mb-2 hover:text-gray-500 hover:bg-indigo-100 hover:text-indigo-600 p-1 rounded-md list-none">
                                    Become a personal trainer
                                </li>
                                <li @click="goTo('/become-a-yoga-instructor')" class="px-4 cursor-pointer mb-2 hover:text-gray-500 hover:bg-indigo-100 hover:text-indigo-600 p-1 rounded-md list-none">
                                    Become a yoga instructor
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="!$page.props.user" class="col-span-4 sm:col-span-4 md:col-span-3 h-10 justify-between justify-self-end divide-non py-3">
                    <a href="/login" class="space-x-8 mx-4 transition duration-500 ease-in-out hover:bg-indigo-600 px-2 p-1 rounded-full hover:text-white hover:shadow-xl bg-indigo-100">Log in</a>
                    <a href="/register?role=student" class="text-white transition duration-500 ease-in-out bg-yellow-300 rounded-full px-2 p-1 shadow-lg hover:shadow-xl hover:bg-yellow-400 custom-button">Sign up</a>
                </div>
                <div v-else class="col-span-4 sm:col-span-4 md:col-span-3 h-10 justify-between justify-self-end divide-non">
                    <div v-if="isClientSide()" class="ml-3 relative">
                        <jet-dropdown align="right" width="48">
                            <template #trigger>
                                <div class="flex">
                                    <!-- <span class="material-icons inline text-gray-500 mx-3 mt-2">
                                        notifications
                                    </span> -->
                                    <button class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition mx-3">
                                        <img :align="$page.props.user.first_name" class="h-10 w-10 rounded-full object-cover" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.first_name"/>
                                    </button>
                                    <!-- <span class="inline-flex rounded-md -mt-2">
                                        <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 hover:text-gray-700 focus:outline-none transition">
                                            {{ $page.props.user.first_name }}

                                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                            </svg>
                                        </button>
                                    </span> -->
                                </div>
                            </template>

                            <template #content>
                                <!-- Account Management -->
                                <div class="block px-4 py-2 text-xs text-gray-400">
                                    Profile management
                                </div>

                                <jet-dropdown-link :href="$page.props?.user?.role==='master' ? '/dashboard/master/courses' : '/dashboard/user/profile'" as="a">
                                    profile
                                </jet-dropdown-link>

                                <jet-dropdown-link as="a" v-if="$page.props.user.is_admin===1" href="/dashboard" class="p-3">
                                    Dashboard
                                </jet-dropdown-link>

                                <div class="border-t border-gray-100"></div>

                                <!-- Authentication -->
                                <form @submit.prevent="logout">
                                    <jet-dropdown-link as="button">
                                        logout
                                    </jet-dropdown-link>
                                </form>
                            </template>
                        </jet-dropdown>
                    </div>
                </div>
            </div>

        </div>
    </header>
    <!-- <main-seek /> -->
</template>

<script>
import Button from "@/Jetstream/Button";
import {Link} from '@inertiajs/inertia-vue3'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import myMixin from "@/myMixin";
import EmailVerifiedMessage from "@/Components/Auth/EmailVerifiedMessage";
import TopBarMessage from "@/Components/elements/TopBarMessage";
// import MainSeek from "@/Pages/Components/MainSeek";

export default {
    name: "Header",
    components: {Button, Link, JetDropdown, JetDropdownLink, EmailVerifiedMessage, TopBarMessage},
    props: {
        navigation_show: {Boolean, default: false},
        configs: Array,
        categories: Array,
    },
    mixins: [myMixin],
    data() {
        return {
            listBox: false,
            joinProfessional: false,
        }
    },
    mounted() {

    },
    computed: {
        menuOptions() {
            return [
                {
                    condition: true,
                    icon: 'person',
                    title: 'Profile', 
                    link: this.$page.props?.user?.role==='master' ? this.route('dashboard.master.get-info') : this.route('profile.show'),
                    active: this.$page.props?.user?.role==='master' ? this.route().current('dashboard.master.get-info') : this.route().current('dashboard.user.get-profile'),
                },
                {
                    condition: true,
                    icon: 'event',
                    title: 'Course',
                    link: this.$page.props?.user?.role==='master' ? this.route('dashboard.master.courses') : this.route('dashboard.user.getCourses'),
                    active: this.$page.props?.user?.role==='master' ? this.route().current('dashboard.master.courses') : this.route().current('dashboard.user.getCourses')
                },
                {
                    condition: true,
                    icon: 'money',
                    title: 'Wallet',
                    link: this.$page.props?.user?.role==='master' ? this.route('dashboard.master.getMyEarn') : this.route('dashboard.user.get-payment-history'),
                    active: this.$page.props?.user?.role==='master' ? this.route().current('dashboard.master.getMyEarn') : this.route().current('dashboard.user.get-payment-history')
                },
                {
                    condition: this.$page.props?.user?.role==='master',
                    icon: 'settings',
                    title: 'Settings',
                    link: this.route('dashboard.master.setting'),
                    active: this.route().current('dashboard.master.setting')
                },
            ]
        }
    },
    watch: {
        navigation_show(val) {
            this.$emit('navigation', val)
        }
    },
    methods: {
        changeHeaderCity(_url) {
            let category = this.$page.props.category;
            return `/${category.url}/${_url}`;
        },
        headerBackground() {
            return this.getCurrentPatch() == '/' || 
                this.getCurrentPatch() == '/become-a-personal-trainer' ||
                this.getCurrentPatch() == '/become-a-yoga-instructor'? false : true;
        },
        getCurrentUrl() {
            return (process.browser && typeof window !== "undefined") ? window.location.href : null;
        },
        logout() {
            this.$inertia.post('/logout');
        },
        goTo(_link){
            window.location.href = _link;
        }
    }
}
</script>

<style scoped>

.menu-icon {
    font-size: 24px;
}

.menu-profile {
    width: 100px !important;
}
</style>
